import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const requestRentSlice = createSlice({
  name: "requestRentSlice",
  initialState,
  //REDUCER
  reducers: {
    setRentalItems(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    // addItems(state, action) {
    //   return {
    //     ...state,
    //     rows: [...state.rows, action.payload],
    //   };
    // },
    // editItems(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.map((row) =>
    //       row.id === action.payload.id ? action.payload : row
    //     ),
    //   };
    // },
    // deleteItems(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.filter((row) => row.id !== action.payload),
    //   };
    // },
  },
});

//ACTIONS
export const {
    setRentalItems,
    showLoading,
    hideLoading,
    // addItems,
    // editItems,
    // deleteItems,
} = requestRentSlice.actions;

export default requestRentSlice.reducer;
